import { useRef } from "react";
import api, { API } from "@/lib/api";
import { toast } from "sonner";
import useLongPress from "@/lib/useLongPress";
import { Trash } from "@phosphor-icons/react";

export default function PhotoThumb({ photo, index, onClick, onDeleted }) {
  const suppressClickRef = useRef(false);

  const confirmDelete = async () => {
    suppressClickRef.current = true;
    // Small vibrate feedback on supported devices
    if (typeof navigator !== "undefined" && navigator.vibrate) navigator.vibrate(20);
    const ok = window.confirm(`Delete photo "${photo.filename}"? This can't be undone.`);
    if (!ok) return;
    try {
      await api.delete(`/documents/${photo.id}`);
      toast.success("Photo deleted");
      onDeleted?.(photo.id);
    } catch {
      toast.error("Delete failed");
    }
  };

  const { props: pressProps, firedRef } = useLongPress(confirmDelete, { delay: 550 });

  const handleClick = () => {
    if (firedRef.current || suppressClickRef.current) {
      firedRef.current = false;
      suppressClickRef.current = false;
      return;
    }
    onClick?.(index);
  };

  return (
    <button
      data-testid={`log-photo-thumb-${photo.id}`}
      onClick={handleClick}
      {...pressProps}
      className="group relative shrink-0 w-28 h-28 rounded-xl overflow-hidden border border-slate-200 hover:ring-2 hover:ring-teal-400 focus:ring-2 focus:ring-teal-400 transition"
      title="Tap to open · long-press to delete"
    >
      <img src={`${API}/files/${photo.id}`} alt={photo.filename} className="w-full h-full object-cover pointer-events-none" draggable={false} />
      <span aria-hidden="true" className="absolute inset-x-0 bottom-0 h-6 bg-gradient-to-t from-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity flex items-center justify-end pr-1.5">
        <Trash size={12} weight="fill" className="text-white/85" />
      </span>
    </button>
  );
}
